import Container from "react-bootstrap/esm/Container";
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

import ss from "../images/screenshot.png"
import dlfile from "../files/ElementData_1.2.3_setup.exe"
import dlfileLinux from "../files/ElementData_1.2.3_linux.zip"
import dlfileLinuxCLI from "../files/ElementData_1.2.3_linux_cli.zip"
import dlfilearm32 from "../files/ElementData_1.2.3_arm32_cli.zip"
import dlfilearm64 from "../files/ElementData_1.2.3_arm64_cli.zip"
import dlfileMac from "../files/ElementData_1.2.3_macOS.zip"

export default function Download() {
  return (
    <Container>
      <Card className="text-center" bg="primary" border="secondary" text="light">
        <Card.Img variant="top" src={ss} />
        <Card.Body>
          <Card.Title><i className="bi bi-windows h3"></i></Card.Title>
          <Card.Text id="card-header" className="text-white">windows</Card.Text>
          <Card.Text id="card-text">v1.2.3</Card.Text>
          <Card.Text id="card-text">Supported versions : w10, w11 x64</Card.Text>
          <Card.Text id="card-text">Run the setup file and proceed with the configuration</Card.Text>
          <Button variant="dark" href={dlfile}>Download</Button>
        </Card.Body>
      </Card>
      <br />
      <Card className="text-center" bg="success" border="secondary" text="light">
        <Card.Body>
          <Card.Title><i className="bi bi-ubuntu h3"></i></Card.Title>
          <Card.Text id="card-header" className="text-white">linux</Card.Text>
          <Card.Text id="card-text">v1.2.3</Card.Text>
          <Card.Text id="card-text">Desktop GUI / CLI x64</Card.Text>
          <Card.Text id="card-text">Raspberry Pi CLI arm32 / arm64</Card.Text>
          <Card.Text id="card-text">Extract the archive, place the file in the desired directory and run it</Card.Text>
          <Card.Text id="card-text">Dependencies : Qt Network</Card.Text>
          <Card.Text id="card-text">For the CLI versions you will find the Instructions.txt file inside the archive</Card.Text>
          <Card.Text id="card-text">If you wish to use Docker, just follow the instructions in the Docker repo page</Card.Text>
          <Button variant="dark" href={dlfileLinux}>Download GUI version</Button>
          <br />
          <br />
          <Button variant="dark" href={dlfileLinuxCLI}>Download CLI x64 version</Button>
          <br />
          <br />
          <Button variant="dark" href={dlfilearm32}>Download CLI arm32 version</Button>
          <br />
          <br />
          <Button variant="dark" href={dlfilearm64}>Download CLI arm64 version</Button>
          <br />
          <br />
          <Button variant="dark" href="https://hub.docker.com/r/elementdata/elementdata_cli" target="_blank">Docker version</Button>
        </Card.Body>
      </Card>
      <br />
      <Card className="text-center" bg="danger" border="secondary" text="light">
        <Card.Body>
          <Card.Title><i className="bi bi-apple h3"></i></Card.Title>
          <Card.Text id="card-header" className="text-white">Mac</Card.Text>
          <Card.Text id="card-text">v1.2.3</Card.Text>
          <Card.Text id="card-text">Extract the zip file and copy/move the app to your Applications folder and run it from there.</Card.Text>
          <Card.Text id="card-text">If you get a message saying the app can't be opened, just right click on the app and choose Open.</Card.Text>
          <Card.Text id="card-text">You'll get the dialog again but with a button to open the app correctly</Card.Text>
          <Button variant="dark" href={dlfileMac}>Download</Button>
        </Card.Body>
      </Card>
      <div className="text-center">
        <hr />
        <p>Settings.ini file is located in AppData folder (press Win+R and type %appdata%) then go into ElementData folder</p>
        <p>Once you're logged in it's a good idea to make a backup of the config file</p>
        <p>For Linux and Mac it's in the .config directory</p>
        <p>If your device is registered and you want to use the app on other PC, copy the settings file to that location on that new PC</p>
        {/* <p>Make sure you remember your password, you can change it later on the website</p> */}
        <hr />
      </div>
      <br />
      <br />
      <br />
      <br />
    </Container>

  );
}
